import axios from "axios"

const Interceptor = {

  status401: async function () {
    axios.interceptors.response.use(
      (response) => { return response; },
      (error) => {
        if (401 === error.response.status) { window.location.href = '/login'; }
        else { return Promise.reject(error); }
      }
    );
  },

  acceptJsonOnly: async function () {
    axios.defaults.headers.common = {
      "Accept": "application/json"
    };
  }

};

export default Interceptor;